import { MobileDeviceFullState } from './schema/MobileDeviceFullState';
import { createStore } from 'satcheljs';

export let mobileDeviceFullStore = createStore<MobileDeviceFullState>('mobileDeviceFullStore', {
    devices: [],
    selected: -1,
    isLoggingOpen: false,
    isDetailsOpen: false,
    notSendReadReceipt: true,
    isLoggingEnabled: false,
    isDevicesDirty: false,
    isLoggingEnabledDirty: false,
    isNotSendReadReceiptDirty: false,
    casMailbox: {},
    deviceStatistics: [],
    isDeviceWipeOpen: false,
    isDeviceWipeDirty: false,
    isAccountOnlyDeviceWipe: false,
    isUnwipeDevice: false,
});
